// MainRouter.js
import React from "react";
import { Routes, Route } from "react-router-dom"; // Remove BrowserRouter import
import App from "./App"; // Import the main App component
import Contact from "./Contact"; // Use PascalCase for component names
import About from "./About"; // Use PascalCase for component names
import Team from "./Team";
import Support from "./Support";
import Assurance from "./Assurance";
import Confidentiality from "./Confidentiality";
import Future from "./Future";
import Focus from "./Focus";
import Indemnity from "./Indemnity"; // Use PascalCase for component names

function MainRouter() {
  return (
    <Routes>
      {/* Home Route */}
      <Route path="/" element={<App />} />
      
      {/* Contact Route */}
      <Route path="/contact" element={<Contact />} />

      {/* Other Routes */}
      <Route path="/about" element={<About />} />
      <Route path="/team" element={<Team />} />
      <Route path="/support" element={<Support />} />
      <Route path="/assurance" element={<Assurance />} />
      <Route path="/confidentiality" element={<Confidentiality />} />
      <Route path="/focus" element={<Focus />} />
      <Route path="/future" element={<Future />} />
      <Route path="/indemnity" element={<Indemnity />} />
    </Routes>
  );
}

export default MainRouter;